import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, apiError } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, object = logged in
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        setToken(null);
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = useCallback(async (username, password, remember = true) => {
    try {
      const { data } = await api.post("/auth/login", { username, password, remember });
      setToken(data.token, remember);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, ready, login, logout }}>{children}</AuthCtx.Provider>;
}
